export const supabaseConnectionsResource = {
  name: 'Supabase 連線',
  fields: {
    name: '名稱',
    description: '描述',
    environment: '環境',
    supabaseUrl: 'Supabase 網址',
    serviceKey: '服務金鑰',
    // anonKey: '匿名金鑰', -- removed, not used in system
    databaseUrl: '資料庫網址',
    isActive: '啟用',
    isDefault: '預設連線',
    status: '狀態',
    credentials: '憑證',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    lastTested: '最後測試時間',
    createdBy: '建立者',
  },
  list: {
    subtitle: '管理 OCPP 伺服器的 Supabase 連線',
    filters: {
      activeOnly: '僅顯示啟用',
    },
  },
  create: {
    title: '建立 Supabase 連線',
    subtitle: '為 OCPP 伺服器設定新的 Supabase 連線',
  },
  edit: {
    title: '編輯 Supabase 連線',
    subtitle: '更新連線設定與憑證',
  },
  show: {
    subtitle: '檢視連線詳情並管理連結的伺服器',
  },
  sections: {
    basic: '基本資訊',
    credentials: '憑證',
    settings: '設定',
    metadata: '中繼資料',
    connectedServers: '已連接的 OCPP 伺服器',
    connectionDetails: '連線詳情',
  },
  helpers: {
    name: '此連線的描述性名稱',
    description: '此連線的選擇性描述',
    environment: '選擇此連線的環境',
    supabaseUrl: 'Supabase 專案網址 (https://xxxx.supabase.co)',
    serviceKey: '具有完整資料庫存取權限的服務角色金鑰',
    // anonKey: '用於公開 API 存取的匿名金鑰', -- removed, not used in system
    databaseUrl: 'PostgreSQL 連線字串（選用）',
    isActive: '啟用或停用此連線',
    isDefault: '將此設為新伺服器的預設連線',
    updateServiceKey: '留空以保留現有金鑰',
    // updateAnonKey: '留空以保留現有金鑰', -- removed, not used in system
    updateDatabaseUrl: '留空以保留現有網址',
  },
  placeholders: {
    leaveEmpty: '留空以保留現有值',
  },
  statuses: {
    active: '啟用',
    inactive: '停用',
  },
  actions: {
    testConnection: '測試連線',
    testing: '測試中...',
    updateCredentials: '更新憑證',
    cancelUpdate: '取消更新',
    assignServers: '指派伺服器',
    unlinkServer: '取消連結',
    assign: '指派',
  },
  info: {
    credentials: '所有憑證將在儲存前加密',
    existingCredentials: '現有憑證已加密並安全儲存',
  },
  warnings: {
    credentialUpdate: '更新憑證將影響所有已連接的 OCPP 伺服器',
  },
  messages: {
    noConnectedServers: '沒有 OCPP 伺服器連接到此 Supabase 實例',
    noAvailableServers: '沒有可指派的 OCPP 伺服器',
    connectionSuccess: '連線成功！',
    connectionFailed: '連線失敗',
  },
  badges: {
    primary: '主要',
    serviceKey: '服務金鑰',
    databaseUrl: '資料庫網址',
  },
  environments: {
    production: '正式環境',
    staging: '預備環境',
    development: '開發環境',
    uat: '測試環境',
  },
  confirmations: {
    unlinkServer: '確定要取消連結此伺服器嗎？',
  },
  dialogs: {
    assignServers: {
      title: '指派 OCPP 伺服器',
      info: '選擇要連接到此 Supabase 連線的 OCPP 伺服器。您可以指定一個伺服器為主要伺服器。',
    },
  },
};

export const supabaseConnections = {
  supabaseConnections: supabaseConnectionsResource,
};